import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "justify-center no-margin flex" };
const _hoisted_2 = { class: "no-padding text-center" };
const _hoisted_3 = { class: "dialog-content" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "mt-5" };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "mt-5" };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = { class: "mt-5 text-left" };
const _hoisted_10 = { key: 3 };
const _hoisted_11 = { class: "mt-5 text-left" };
const _hoisted_12 = { key: 4 };
const _hoisted_13 = { class: "mt-5 text-left" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnFormDialog"], {
        modelValue: $setup.model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.model) = $event)),
        title: $setup.t('common.dataGrid.exportAll.label'),
        width: "550px",
        onClose: $setup.close
    }, {
        content: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        ($setup.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", null, [
                                    _createVNode($setup["EnSpinner"], { big: "" })
                                ]),
                                _createElementVNode("div", _hoisted_5, _toDisplayString($setup.t('common.dataGrid.exportAll.text')), 1 /* TEXT */)
                            ]))
                            : ($setup.isCanceled)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("div", null, [
                                        _createVNode($setup["EnIcon"], {
                                            color: "error",
                                            size: "72"
                                        }, {
                                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                    _createTextVNode("mdi mdi-cancel", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_7, _toDisplayString($setup.t('common.dataGrid.exportAll.cancelText')), 1 /* TEXT */)
                                ]))
                                : ($setup.isSuccess)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _createElementVNode("div", null, [
                                            _createVNode($setup["EnIcon"], {
                                                color: "success",
                                                size: "72"
                                            }, {
                                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                        _createTextVNode("mdi mdi-check-circle-outline", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createTextVNode(_toDisplayString($setup.t('common.dataGrid.exportAll.finishText')) + " ", 1 /* TEXT */),
                                            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                            _createElementVNode("a", {
                                                onClick: $setup.downloadExport,
                                                class: "mt-2 download-export-link"
                                            }, _toDisplayString($setup.t('common.dataGrid.exportAll.export')), 1 /* TEXT */)
                                        ])
                                    ]))
                                    : ($setup.hasTooManyRowsError)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _createElementVNode("div", null, [
                                                _createVNode($setup["EnIcon"], { size: "72" }, {
                                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                                            _createTextVNode("mdi mdi-arrow-collapse-vertical", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _createElementVNode("div", _hoisted_11, _toDisplayString($setup.t('common.dataGrid.exportAll.tooManyRowsText')), 1 /* TEXT */)
                                        ]))
                                        : ($setup.hasError)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                _createElementVNode("div", null, [
                                                    _createVNode($setup["EnIcon"], { size: "72" }, {
                                                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                                _createTextVNode("mdi mdi-robot-confused-outline", -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _createElementVNode("div", _hoisted_13, _toDisplayString($setup.t('common.error.unknown')), 1 /* TEXT */)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ])
        ]),
        "close-button": _withCtx(() => [
            ($setup.isLoading)
                ? (_openBlock(), _createBlock($setup["EnButton"], {
                    key: 0,
                    "static-id": "cancel-export-button",
                    variant: "default",
                    rounded: "",
                    height: "36px",
                    width: "100px",
                    onClick: $setup.cancel
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('common.dataGrid.cancel')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }))
                : (_openBlock(), _createBlock($setup["EnButton"], {
                    key: 1,
                    "static-id": "export-all-close-button",
                    variant: "default",
                    rounded: "",
                    height: "36px",
                    width: "100px",
                    onClick: $setup.close
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('common.dataGrid.exportAll.close')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }))
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "title"]));
}
